import { InputProps, Space, Typography } from "antd";
import React, { useMemo, useState } from "react";
import color from "../../../../theme/color";
import { InputStyled } from "./index.styled";

interface SearchInputProps extends Omit<InputProps, "onChange"> {
  value?: string;
  onChange?: (value: string) => void;
}

/**
 * 검색용 Input 정규식 처리 (sql injection)
 * @param param0
 * @returns
 */
export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange = () => void 0,
  prefix,
  style,
  ...props
}) => {
  const [focus, setFocus] = useState(false);

  const reg = new RegExp("[<>'\"%]", "gmi");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    const beautifulText = inputValue.replace(reg, "");
    onChange(beautifulText);
  };

  const labelPrefix = useMemo(() => {
    if (prefix) {
      return (
        <Space size={6}>
          {prefix}
          {value?.trim() && props?.placeholder && focus === false && (
            <Typography.Text style={{ fontWeight: 700, color: color.gray4 }}>
              {props.placeholder}
            </Typography.Text>
          )}
        </Space>
      );
    }
    return undefined;
  }, [prefix, props, focus, value]);

  return (
    <InputStyled
      className={value ? "ant-input-affix-wrapper-focused" : undefined}
      {...props}
      value={value}
      allowClear
      onChange={handleChange}
      onFocus={() => {
        setFocus(true);
      }}
      onBlur={() => {
        setFocus(false);
      }}
      {...(labelPrefix && { prefix: labelPrefix })}
      style={{ height: 32, ...style }}
    />
  );
};
